import { getPhotographer, getAllMediasForPhotographer } from "../../../app/lib/prisma-db";
import PhotographerHeader from "./components/PhotographerHeader/PhotographerHeader";
import PhotographerMedias from "./components/PhotographerMedias/PhotographerMedias";

export default async function Page({params}){
    const { slug } = await params;
    const id = parseInt(slug.split("-")[0]);
    const photographer = await getPhotographer(id);
    const medias = await getAllMediasForPhotographer(id);

    return(
        <>
            <PhotographerHeader 
                photographer={photographer}
            />
            <PhotographerMedias
                photographer={photographer}
                medias={medias}
            />
        </>
    )
}

